module.exports = __webpack_public_path__ + "img/mi.91738bd7.jpg";